import { z } from 'zod';

export const PREDICTION_TERMINAL = ['succeeded', 'failed', 'canceled'] as const;
export const PredictionStatusSchema = z.enum([
  'starting',
  'processing',
  'succeeded',
  'failed',
  'canceled',
]);
export type PredictionStatus = z.infer<typeof PredictionStatusSchema>;

export function isTerminalStatus(s: PredictionStatus): boolean {
  return (PREDICTION_TERMINAL as readonly string[]).includes(s);
}

export const PredictionSchema = z.object({
  id: z.string(),
  replicateId: z.string(),
  modelSlug: z.string(),
  kind: z.enum(['llm', 'image']),
  status: PredictionStatusSchema,
  output: z.unknown().optional(),
  error: z.string().optional(),
  predictTimeSec: z.number().optional(),
  costUsd: z.number().optional(),
  inputTokens: z.number().optional(),
  outputTokens: z.number().optional(),
  startedAt: z.number(),
  completedAt: z.number().optional(),
});
export type Prediction = z.infer<typeof PredictionSchema>;
